export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
    <path d="M10.5009 0.599609L0.642578 10.4579L10.5009 0.599609Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M10.3583 10.4579L0.5 0.599609L10.3583 10.4579Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
)
